import styled from '@emotion/styled';
import { colors } from 'constants/colors';

export const Container = styled('div')({
  marginTop: -30,
});

export const WhiteContainer = styled('div')({
  width: '100%',
  borderRadius: 8,
  backgroundColor: colors.WHITE,
  padding: 24,
  marginBottom: 20,
});

export const FileContainer = styled('div')({
  width: '100%',
  backgroundColor: colors.LIGHTGREY,
  padding: 10,
  borderRadius: 6,
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 10,
});

export const InfoFlex = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});

export const IconShowPdf = styled('img')({
  cursor: 'pointer',
});
